export const SUPPLY_CHAIN_DASHBOARD_URL =
  process.env.REACT_APP_SUPPLY_CHAIN_DASHBOARD_URL ||
  "https://supply-chain.seeds-prima.cloud";
  // "http://localhost:8000/";
